import React from 'react';
import { Body, Micro } from '@vds/typography';
import './FloatingCart.css';

function CustomTableRow(props) {
	const { offerName, price, offerString, installmentOption } = props;
	const finalPrice = price ? price : offerString;

	return (
		<div className="Cart-Items">
			<div className="Cart-Label">
				<span>
					<Body size="medium" primitive="h2">
						{offerName}
					</Body>
					<Micro primitive="h2">{installmentOption}</Micro>
				</span>
			</div>
			<div className="Cart-data">
				<Body size="medium" primitive="h2">
					{finalPrice}
				</Body>
			</div>
		</div>
	);
}

export default CustomTableRow;
